/**
 * Values shared between the server page (metadata) and the client components.
 *
 * These deliberately live apart from content.tsx: that module imports the
 * ui-kit, which is client-only, so importing anything from it inside the
 * server page would pull React hooks into the server graph and fail the build.
 */

export const PAGE_TITLE = "Using AI in Our Interview Process";

/** Shown above the copy. Keep in step with any change to content.tsx. */
export const LAST_UPDATED = "07.24.2026";